"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostalAddressPreview = exports.PlacePreview = void 0;
const react_1 = __importDefault(require("react"));
require("./PlacePreview.scss");
const PlacePreview_scss_json_1 = __importDefault(require("./PlacePreview.scss.json"));
const package_1 = require("../package");
const Place_1 = require("lincd-schema/lib/shapes/Place");
const Hooks_1 = require("lincd/lib/utils/Hooks");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
const PostalAddress_1 = require("lincd-schema/lib/shapes/PostalAddress");
exports.PlacePreview = (0, package_1.linkedComponent)(Place_1.Place.request((place) => ({
    name: place.name,
})), (_a) => {
    var { source, linkedData: { name }, variant = 'default', onRemove } = _a, restProps = __rest(_a, ["source", "linkedData", "variant", "onRemove"]);
    restProps = (0, Hooks_1.useStyles)(restProps, [PlacePreview_scss_json_1.default.PlacePreview, PlacePreview_scss_json_1.default[variant]]);
    return (react_1.default.createElement("div", Object.assign({}, restProps),
        react_1.default.createElement("p", { className: PlacePreview_scss_json_1.default.placePreviewText }, name),
        onRemove && (react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/icons/RemoveIcon.svg'), alt: "remove icon", className: PlacePreview_scss_json_1.default.removeIcon, onClick: () => onRemove(source) }))));
});
// Person.address -> PostalAddress.AdministrativeArea.name
exports.PostalAddressPreview = (0, package_1.linkedComponent)(PostalAddress_1.PostalAddress.request((postalAddress) => {
    var _a;
    return {
        areaServedName: (_a = postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.areaServed) === null || _a === void 0 ? void 0 : _a.name,
    };
}), (_a) => {
    var { source, linkedData: { areaServedName }, variant = 'default', onRemove } = _a, restProps = __rest(_a, ["source", "linkedData", "variant", "onRemove"]);
    restProps = (0, Hooks_1.useStyles)(restProps, [PlacePreview_scss_json_1.default.PlacePreview, PlacePreview_scss_json_1.default[variant]]);
    return (react_1.default.createElement("div", Object.assign({}, restProps),
        react_1.default.createElement("p", { className: PlacePreview_scss_json_1.default.placePreviewText }, areaServedName),
        onRemove && (react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/icons/RemoveIcon.svg'), alt: "remove icon", className: PlacePreview_scss_json_1.default.removeIcon, onClick: () => onRemove(source) }))));
});
//register all components in this file
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=PlacePreview.js.map